import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { OrganizationService } from '../shared/services/organization.service';
import { Validators, FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { FormControl } from '@angular/forms';
import * as firebase from 'firebase/app'
import { UtilityService } from '../shared/services/utility.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router'; // <-- do not forget to import
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
import { ChangeDetectorRef } from '@angular/core';
import { ElementRef, NgZone, ViewChild } from '@angular/core';

import { WidgetService } from './widget/widget.service';


declare var google: any;
@Component({
  selector: 'appc-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})



export class HomeComponent implements OnInit {

  widgets: any;

  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;
  public center: any;
  public infoposition: boolean = true;
  private fragment: string;
  public OrganisationCount:any;
  public ProjectCount: any;

  @ViewChild("search")
  public searchElementRef: ElementRef;



  autocomplete: google.maps.places.Autocomplete;
  address: any = {};
  jsonaddr: string = 'none';
  public positions = [];
  public organisationPositions = [];
  public centerPosition = [];

  public marker = {
    display: true,
    lat: null,
    lng: null,
    name: '',
    content: '',
    projId: '',
    orgId: '',
    projButton: false,
    orgButton: false,
    typeName: '',
    type: '',
    address: '',
    draggable: false,
    label: ''


  };
  infoWindowOpened = null;

  orgTable: FirebaseListObservable<any[]>;
  projTable: FirebaseListObservable<any[]>;
  orgData: Array<object>;
  projData: Array<object>;


  constructor(
    private ref: ChangeDetectorRef,
    private db: AngularFireDatabase,
    public orgService: OrganizationService,
    public router: Router,
    public utility: UtilityService, private route: ActivatedRoute, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,public ws: WidgetService
  ) {

    this.orgData = [];
    this.projData = [];
    this.getOrganisationList();
    this.getProjectList();
    var firebaseRef = firebase.database().ref('organizations/');

  }





  initialized(autocomplete: any) {
    this.autocomplete = autocomplete;
  }

  


  ngAfterViewInit(): void {
    try {
      document.querySelector('#' + this.fragment).scrollIntoView();
    } catch (e) { }
  }
  
  put() {
    this.ws.put();
  }

  ngOnInit() {
    this.widgets = this.ws.get();

    // this.OrganisationCount = 0;
    // this.ProjectCount = 0;

    //create search FormControl
    this.searchControl = new FormControl();
    //set current position
    this.setCurrentPosition();
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["geocode"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          
          
        });
      });
    });

    this.route.fragment.subscribe(fragment => { this.fragment = fragment; });

  }

  private convertStringToNumber(value: string): number {
    return +value;
  }

  private setCurrentPosition() {
    this.zoom = 2;
    
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 2;
      });
    }
  }

  onMapReady(map) {
    //console.log('map', map);
    //console.log('markers', map.markers);  // to get all markers as an array 

  }

  clickedMarker(label: string, index: number) {
   // console.log(`clicked the marker: ${label || index}`)
  }



  markerDragEnd($event) {
    console.log('dragEnd', $event);
  }


  gotoSearch() {
    this.router.navigateByUrl('/home/#search');
  }

  getOrganisationList() {
    //console.log('Called getOrganisationList function')
    this.db.list('/organizations', { preserveSnapshot: true })
      .subscribe(orgRes => {
        orgRes.forEach(orgListRes => {
          this.orgTable = orgListRes.val();
          var key = orgListRes.key;
          this.orgTable['orgKey'] = orgListRes.key;
          if(this.orgTable['orgStatus'] === true)
          this.orgData.push(this.orgTable);
        });
        for (var i = 0; i < this.orgData.length; i++) {
         // console.log('This is the looped data of organisation ' + JSON.stringify(this.orgData.length));
          this.OrganisationCount= this.orgData.length
          if (this.orgData[i]['latitude'] == null || this.orgData[i]['longitude'] == null) {
            //console.log('This is the null form of coordinates')
          }
          else if (this.orgData[i]['latitude'] == "" || this.orgData[i]['longitude'] == "") {
            //console.log('This is the empty string form of coordinates')
          } else {
            //console.log('This is the actual coordinates block ' + this.orgData[i]['orgKey'])
            var organisationPosObj = {
              'lat': '' + this.orgData[i]['latitude'],
              'lng': '' + this.orgData[i]['longitude'],
              'label': 'O',
              'orgId': '' + this.orgData[i]['orgKey'],
              'details': '' + this.orgData[i]['address'],
              'name': 'Organisation',
              'iconUrl': '../../assets/img/markers/yellow-dot.png',
              'typeName': '' + this.orgData[i]['orgName'],
              'type': '' + this.orgData[i]['orgType'],
              'address': '' + this.orgData[i]['address'],
              'draggable': false
            }
            this.organisationPositions.push(organisationPosObj)
            //console.log('This is the organisationPositions pushed value ' + JSON.stringify(this.organisationPositions))
          }
        }
      })
  }

  getProjectList() {
    //console.log('The getProjectList is called')
    this.db.list('/projects', { preserveSnapshot: true })
      .subscribe(projRes => {
        //console.log('This is the project response ' + JSON.stringify(projRes))
        projRes.forEach(projListRes => {
          this.projTable = projListRes.val();
          this.projData.push(this.projTable)
        });
        var b = "";
        for (var i = 0; i < this.projData.length; i++) {
          //console.log('This is the looped projectData ' + JSON.stringify(this.projData[i]['projectid']))
          this.ProjectCount= this.projData.length
          if (this.projData[i]['latitude'] == null || this.projData[i]['longitude'] == null) {
            //console.log('This is the null form of coordinates for projects ')
            return false;
          }
          if (this.projData[i]['latitude'] == "" || this.projData[i]['longitude'] == "") {
            //console.log('This is the empty string form of coordinates for projects')
            return false;
          } else {
            //console.log('This is the actual coordinates block for projects ' + this.projData[i]['projectid'])
            var projectPosObj = {
              'lat': '' + this.projData[i]['latitude'],
              'lng': '' + this.projData[i]['longitude'],
              'label': 'P',
              'projId': '' + this.projData[i]['projectid'],
              'details': '' + this.projData[i]['description'],
              'name': 'Projects',
              'iconUrl': '../../assets/img/markers/blue-dot.png',
              'typeName': '' + this.projData[i]['name'],
              'type': '' + this.projData[i]['projectType'],
              'address': '' + this.projData[i]['projectAddress'],
              'draggable': false
            }
            this.organisationPositions.push(projectPosObj)
            //console.log('This is the projectPositions pushed value ' + JSON.stringify(this.organisationPositions))
          }
        }
      })
  }



  OrgProjPosition(x, infoWindow) {
    //console.log('This is the orgProjPosition ' + JSON.stringify(x))
    if (this.infoWindowOpened === infoWindow)
      return;

    if (this.infoWindowOpened !== null)
      this.infoWindowOpened.close();

    this.marker.name = x.name;
    this.marker.typeName = x.typeName;
    this.marker.type = x.type;
    this.marker.address = x.address
    this.marker.content = x.details;
    if (x.projId == null) {
      //console.log('The projectId is null at marker')
    } else {
      //console.log('The projectId is not null at marker')
      this.marker.projId = x.projId;
      this.marker.projButton = true;
      this.marker.orgButton = false;
    }
    if (x.orgId == null) {
      //console.log('The orgId is not null at marker')
    } else {
      //console.log('The orgId is not null at marker')
      this.marker.orgId = x.orgId;
      this.marker.orgButton = true;
      this.marker.projButton = false;
    }
    //marker.openInfoWindow('iw-container', marker);
    this.infoWindowOpened = infoWindow;
  }

  hideMarkerInfo() {
    this.marker.display = !this.marker.display;
  }

  orgMoreInfo(x) {
    //console.log('This is the organisation more info '+x)
    if (x == null || x == 'undefined') {
      //console.log('organisation Id unavailable')
      return false;
    } else {
      //console.log('This is organisation id not null')
      this.router.navigateByUrl('/org/' + x);
    }
  }

  projMoreInfo(x) {
    //console.log('This is the project more info ' + x)
    if (x == null || x == 'undefined') {
      //console.log('project Id unavailable')
      return false;
    } else {
      //console.log('This is project id not null')
      this.router.navigateByUrl('/project/' + x);
    }
  }


}



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/home/home.component.ts